import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';

import { CreditAgreementRoute } from './CreditAgreementRoute';
import { CreditAgreementsRoute } from './CreditAgreementsRoute';

export const CreditAgreementsRouter = () => {
  return (
    // Paths relative to "/credit-agreements/*"
    <Routes>
      <Route path="/" element={<CreditAgreementsRoute />} />
      <Route path="/:creditAgreementId" element={<CreditAgreementRoute />} />
      <Route path="/*" element={<Navigate to="/credit-agreements" />} />
    </Routes>
  );
};
